import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { UsersPlansSummaryActions } from '../../../core/store/actions/users-plans-summary.actions';
import { UsersPlansSummarySelectors } from '../../../core/store/selectors/users-plans-summary.selectors';
import { AuthService } from '@shared/services/auth/auth.service';

@Component({
    selector: 'app-float-bar',
    imports: [CommonModule, RouterModule],
    templateUrl: './float-bar.component.html',
    styleUrl: './float-bar.component.scss'
})
export class FloatBarComponent implements OnInit {
  username: string = 'Usuario';

  private authService = inject(AuthService);

  constructor(private store: Store) {
    const filters$ = this.store.select(
      UsersPlansSummarySelectors.selectFilters
    );

  }

  ngOnInit(): void {
    const user = this.authService.getAuthData()?.user;

    if (user?.firstName && user?.lastName) {
      this.username = `${user.firstName} ${user.lastName}`;
    }
  }

  ngOnDestroy(): void {
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search((event.target as HTMLInputElement)?.value ?? '');
    }
  }


  logout() {
    this.authService.logout();
  }

  private search(value: string): void {
    this.loadUsers(value);
  }

  private loadUsers(value: string) {
    this.store.dispatch(UsersPlansSummaryActions.setFiltersAndPaginatedData({
      filters:{
        search: value,
      },
      paginatedData: {
        pageNumber: 1
      }
    }));
  }
}
